const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
const arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];

const toEnglishNumbers = (str: string) => {
  let output = str;

  persianNumbers.forEach((item, index) => {
    output = output.split(item).join(index.toString());
  });
  arabicNumbers.forEach((item, index) => {
    output = output.split(item).join(index.toString());
  });

  return output;
};

const PersianUtil = {
  toEnglishNumbers,
};

export default PersianUtil;
